import React, { useState } from "react";
import { Form, Input, Button, Row, Col, Modal, Typography, message, Select, DatePicker, Radio } from "antd";
import { ExclamationCircleOutlined, DeleteOutlined, PlusCircleOutlined, LeftOutlined, RightOutlined} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";

const { confirm } = Modal;
const { Title, Text } = Typography;
const { Option } = Select;

const LiabilitiesForm = () => {
  const [form] = Form.useForm();
  const [items, setItems] = useState([
    {
      type: "",
      description: "",
      creditor: "",
      balance: "",
      monthlyPayment: "",
      interestRate: "",
      maturityDate: null,
      secured: null,
      collateral: "",
    },
  ]);

  const history = useHistory();

  const addItem = () => {
    setItems([
      ...items,
      {
        type: "",
        description: "",
        creditor: "",
        balance: "",
        monthlyPayment: "",
        interestRate: "",
        maturityDate: null,
        secured: null,
        collateral: "",
      },
    ]);
  };

  const deleteItem = (index) => {
    confirm({
      title: "Are you sure you want to delete this liability?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        setItems(items.filter((_, idx) => idx !== index));
      },
    });
  };

  const onBack = () => {
    history.push(routes.personalHolding.path); 
  };

  const onNext = () => {
    history.push(routes.incomeSources.path); 
  };

  const onFinish = (values) => {
    message.success("Liabilities Saved!");
    console.log("Saved values:", values);
    onNext();
  };

  return (
    <LeftLayout>
      <Row style={{ minHeight: "100vh", background: "#fff" }} align="top" className="rightbox">
        <Col span={24}>
          <Title level={3} style={{ marginTop: 40 }}>
            Liabilities
          </Title>

          <Form form={form} layout="vertical" onFinish={onFinish}>
            {items.map((_, idx) => (
              <div key={idx}>
                <Row justify="space-between" align="middle" style={{ marginTop: 30, marginBottom: 20 }}>
                  <Col>
                    <Text strong style={{ fontSize: 16 }}>
                      Liability {String(idx + 1).padStart(2, "0")}
                    </Text>
                  </Col>
                  <Col>
                    {idx > 0 && (
                      <Button
                        type="text"
                        icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                        onClick={() => deleteItem(idx)}
                      />
                    )}
                  </Col>
                </Row>

                <Form.Item
                  label="Type Of Liability"
                  name={["items", idx, "type"]}
                  rules={[{ required: true, message: "Please select type of liability" }]}
                  className='w50'
                >
                  <Select placeholder="Select">
                    <Option value="loan">Loan</Option>
                    <Option value="creditCard">Credit Card</Option>
                    <Option value="mortgage">Mortgage</Option>
                  
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Description"
                  name={["items", idx, "description"]}
                  rules={[{ required: true, message: "Please enter description" }]}
                  className='w50'
                >
                  <Input.TextArea />
                </Form.Item>

                <Form.Item
                  label="Creditor/Lender Name"
                  name={["items", idx, "creditor"]}
                  className='w50'
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Outstanding Balance"
                  name={["items", idx, "balance"]}
                  className='w50'
                >
                  <Input placeholder="$" />
                </Form.Item>

                <Form.Item
                  label="Monthly Payment Amount"
                  name={["items", idx, "monthlyPayment"]}
                  className='w50'
                >
                  <Input placeholder="$" />
                </Form.Item>

                <Form.Item
                  label="Interest Rate"
                  name={["items", idx, "interestRate"]}
                  className='w50'
                >
                  <Input placeholder="%" />
                </Form.Item>

                <Form.Item
                  label="Maturity Date"
                  name={["items", idx, "maturityDate"]}
                  className='w50'
                >
                  <DatePicker style={{ width: "100%" }} placeholder="MM/DD/YYYY" format="MM/DD/YYYY" />
                 
                </Form.Item>

                <Form.Item
                  label="Is This Liability Secured By Collateral?"
                  name={["items", idx, "secured"]}
                  rules={[{ required: true, message: "Please select an option" }]}
                  className='w50'
                >
                  <Radio.Group>
                    <Radio value="yes">Yes</Radio>
                    <Radio value="no">No</Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item
                  label="Describe The Collateral"
                  name={["items", idx, "collateral"]}
                  className='w50'
                >
                  <Input />
                </Form.Item>
              </div>
            ))}

            <Form.Item>
              <Button
                type="link"
                icon={<PlusCircleOutlined />}
                onClick={addItem}
                style={{
                  padding: 0,
                  fontWeight: "bold",
                  fontSize: 15,
                  marginTop: 10,
                }}
                className='w50'
              >
                Add Another Liability
              </Button>
            </Form.Item>

            <Form.Item>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }} className="w95">
                <Button
                  onClick={onBack}
                  icon={<LeftOutlined />}
                >
                  Go Back
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                >
                  Save And Proceed <RightOutlined />
                </Button>
                <Button
                  type="default"
                  onClick={onNext}
                >
                  Next <RightOutlined />
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </LeftLayout>
  );
};

export default LiabilitiesForm;
